import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from "../lib/lang";
import { useSeo } from "../lib/seo";
import { api } from "../lib/api";

// DEV_MODE bypass is ONLY visible on preview + localhost. Never on the production domain,
// even if the env var was compiled into the bundle.
const IS_PREVIEW_HOST =
  typeof window !== "undefined" &&
  (window.location.hostname.includes(".preview.emergentagent.com") ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");
const DEV_MODE = process.env.REACT_APP_DEV_MODE === "true" && IS_PREVIEW_HOST;

export default function LoginPage() {
  const { t } = useLang();
  const navigate = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/dashboard";
  const [devLoading, setDevLoading] = useState(null);
  useSeo({ title: "Sign in — Brand and Behavior", noindex: true });

  const signIn = () => {
    try { sessionStorage.setItem("post_auth_next", next); } catch (err) { console.warn("sessionStorage unavailable:", err); }
    const redirect = `${window.location.origin}/auth/callback`;
    const url = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
    window.location.href = url;
  };

  const devLogin = async (role) => {
    setDevLoading(role);
    try {
      await api.post("/dev/login", { role });
      if (role === "client") {
        try { await api.post("/dev/seed", {}); } catch (e) { void e; }
        // Full reload so AuthProvider picks up the new session cookie
        window.location.href = "/dashboard";
      } else {
        window.location.href = "/admin";
      }
    } catch (err) {
      console.error("Dev login failed:", err);
      alert("Dev login failed — DEV_MODE may not be enabled on the backend.");
      setDevLoading(null);
    }
  };

  return (
    <main className="app-main" data-testid="login-page">
      <section className="page-hero">
        <div className="kicker">{t("Sign in", "Inicia sesión")}</div>
        <h1>{t("Welcome ", "Bienvenido ")}<em className="it">{t("back", "de nuevo")}</em>.</h1>
        <p>{t("Sign in with Google to access your project dashboard and submit intake forms.", "Inicia sesión con Google para acceder a tu panel de proyectos y enviar cuestionarios.")}</p>
      </section>
      <section style={{ padding: "0 22px 80px" }}>
        <button className="button" onClick={signIn} data-testid="login-google" style={{ fontSize: 12, letterSpacing: ".22em", padding: "16px 28px" }}>
          {t("Continue with Google", "Continuar con Google")}
        </button>

        {DEV_MODE && (
          <div className="dev-login-panel" data-testid="dev-login-panel">
            <div className="dev-login-header">
              <span className="dev-badge">PREVIEW ONLY</span>
              <span>Dev bypass — skip Google auth to explore the app</span>
            </div>
            <div className="dev-login-buttons">
              <button
                className="button ghost"
                onClick={() => devLogin("client")}
                disabled={devLoading !== null}
                data-testid="dev-login-client"
              >
                {devLoading === "client" ? "Signing in…" : "→ Sign in as test CLIENT (with sample paid orders)"}
              </button>
              <button
                className="button ghost"
                onClick={() => devLogin("admin")}
                disabled={devLoading !== null}
                data-testid="dev-login-admin"
              >
                {devLoading === "admin" ? "Signing in…" : "→ Sign in as test ADMIN"}
              </button>
            </div>
            <p className="dev-login-hint">
              This panel only appears when <code>DEV_MODE=true</code> on the backend and <code>REACT_APP_DEV_MODE=true</code> on the frontend. It never appears in production.
            </p>
          </div>
        )}
      </section>
    </main>
  );
}
